package com.essntl.features.itinerary.domain.model

data class DynamicField(
    val fieldName: String,
    val value: String,
    val showOnItinerary: Boolean,
)
